// extracted by mini-css-extract-plugin
export default {"modal_content":"rejectModal_modal_content__i1pc9","top":"rejectModal_top__wtJMR"};